// Core
import { NavigationGuard } from "vue-router";

// Libraries
import { until } from "@vueuse/core";

// Stores
import pinia from "@/store/pinia";
import { useTeamStore } from "@/store/team";

const requireNoActiveSubscription: NavigationGuard = async (_to, _from, next) => {
  try {
    const teamStore = useTeamStore(pinia);
    
    // Aguarda o carregamento inicial da store
    await until(() => teamStore.loading).changedTimes(2);
    
    // Se tem assinatura válida, redireciona para dashboard
    if (teamStore.hasValidSubscription && !teamStore.isPlanInvalid && !teamStore.isSubscriptionLate) {
      console.log("[requireNoActiveSubscription] User has valid subscription, redirecting to dashboard");
      return next({ name: "dashboard" });
    }
    
    // Se não tem assinatura, permite acesso
    next();
  } catch (error) {
    console.error("[requireNoActiveSubscription] Error:", error);
    // Em caso de erro, permite continuar para não bloquear o usuário
    next();
  }
};

export default requireNoActiveSubscription;